import React from 'react';
import { text, formatDate } from '../../lib/formatters.mjs';
import { ActivityTimeline } from '../../ui/index.js';
import { IconPlus, IconFileText, IconSend, IconFlag, IconMessageCircle } from '../../ui/icons.js';

// Presentation follows actual event types; unsupported types retain a neutral marker.
const eventPresentation = {
  REQUESTED: {icon:IconPlus,kind:'request',title:'Teklif talebi oluşturuldu'},
  CREATED: {icon:IconPlus,kind:'request',title:'Teklif talebi oluşturuldu'},
  STAGE_CHANGED: {icon:IconFlag,kind:'stage',title:'İşin durumu güncellendi'},
  PROPOSAL_DRAFTED: {icon:IconFileText,kind:'proposal',title:'Teklif taslağı hazırlandı'},
  PROPOSAL_CREATED: {icon:IconFileText,kind:'proposal',title:'Teklif taslağı hazırlandı'},
  PROPOSAL_SHARED: {icon:IconSend,kind:'shared',title:'Teklif iletimi kaydedildi'},
  NOTE: {icon:IconMessageCircle,kind:'note',title:'Güncelleme eklendi'},
  NOTE_ADDED: {icon:IconMessageCircle,kind:'note',title:'Güncelleme eklendi'},
};
const neutralEvent = {icon:IconFileText,kind:'event',title:'İş kaydı güncellendi'};

export function History({ events = [] }) {
  return <ActivityTimeline items={events.map((event, index) => ({
    id: event.id ?? index,
    icon: (eventPresentation[event.type] || neutralEvent).icon,
    kind: (eventPresentation[event.type] || neutralEvent).kind,
    dateTime: event.at || event.createdAt || undefined,
    body: event.body || event.message || event.description || eventTitle(event.type),
    actor: text(event.actor) || undefined,
    date: formatDate(event.at || event.createdAt, { hour: '2-digit', minute: '2-digit' }),
    internal: event.visibility === 'internal',
  }))} />;
}
function eventTitle(type) { return (eventPresentation[type] || neutralEvent).title; }
